module.exports = __webpack_public_path__ + "capture-bugs-5e06893ba5feeae55de28035124cf2e9.webp";